var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content" }, [
      _c("img", {
        staticClass: "email_fanhui fanzhuan",
        attrs: { src: require("../assets/img/cz_web_return.png") },
        on: {
          click: function($event) {
            return _vm.goback()
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "email_content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("p", { staticClass: "email_contact" }, [
          _vm._v(_vm._s(_vm.$t("m.contact_email")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "email_desc" }, [
          _vm._v(_vm._s(_vm.$t("m.provide_email")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "email_form_title" }, [
          _vm._v(_vm._s(_vm.$t("m.email_address")))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.emailVal,
              expression: "emailVal"
            }
          ],
          staticClass: "email_form_input",
          attrs: {
            type: "email",
            name: "email",
            placeholder: _vm.$t("m.email_place_holder")
          },
          domProps: { value: _vm.emailVal },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.emailVal = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "email_form_btn",
            class: { active: _vm.emailIsTrue },
            on: {
              click: function($event) {
                return _vm.submitEmail()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("m.submit")))]
        )
      ]),
      _vm._v(" "),
      _vm.isInBuzzCast
        ? _c("p", {
            staticClass: "fc-notice",
            domProps: {
              innerHTML: _vm._s(_vm.$t("m.buy-notice-a", { msg: _vm.curHost }))
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.isInBuzzCast
      ? _c("p", { staticClass: "fc-notice ask" }, [
          _c("img", {
            staticClass: "fc-icon-sm",
            attrs: { src: require("../assets/img/question_icon.png") }
          }),
          _vm._v(" "),
          _c("a", { staticClass: "fc-color-gray", attrs: { href: "#/asks" } }, [
            _vm._v(_vm._s(_vm.$t("m.rechargeFAQ_title")))
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticClass: "email_img",
        attrs: { src: require("../assets/img/cz_web_mail.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa473470", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa473470","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/email.vue
// module id = null
// module chunks = 